module.exports = __webpack_public_path__ + "static/media/aveda-products.8aaa8460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Aveda/aveda-products.jpg
// module id = 30
// module chunks = 0